import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import VerifyPage from './VerifyPage';
import ChatPage from './ChatPage';
import DDFTestPage from './DDFTestPage';
import KijijiTestPage from './KijijiTestPage';
import ProfilePage from './ProfilePage';
import MessagesPage from './MessagesPage';
import ActivationPage from './ActivationPage';
import CreditPullPage from './CreditPullPage';
import CreditReportPage from './CreditReportPage';
import MapPage from './MapPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/credit-pull" element={<CreditPullPage />} />
          <Route path="/credit-report" element={<CreditReportPage />} />
          <Route path="/a/:code" element={<ActivationPage />} />
          <Route path="/ddf-test" element={<DDFTestPage />} />
          <Route path="/kijiji-test" element={<KijijiTestPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
